var map = {
	"./black-friday/appliance-banner-mobile.png": 2324,
	"./black-friday/appliance-banner-mobile@2x.png": 2325,
	"./black-friday/appliance-banner.jpg": 2326,
	"./black-friday/appliance-banner@2x.jpg": 2327,
	"./black-friday/background-empty-end.jpg": 2328,
	"./black-friday/background-header-mobile.png": 2329,
	"./black-friday/background-header-mobile@2x.png": 2330,
	"./black-friday/background-header.png": 2331,
	"./black-friday/background-header@2x.png": 2332,
	"./black-friday/black-friday-text.png": 2333,
	"./black-friday/black-friday-text@2x.png": 2334,
	"./black-friday/bottles.jpg": 2335,
	"./black-friday/computer-banner-mobile.png": 2336,
	"./black-friday/computer-banner-mobile@2x.png": 2337,
	"./black-friday/computer-banner.jpg": 2338,
	"./black-friday/computer-banner@2x.jpg": 2339,
	"./black-friday/computer.jpg": 2340,
	"./black-friday/date-end.jpg": 2341,
	"./black-friday/date-start.jpg": 2342,
	"./black-friday/fridge.jpg": 2343,
	"./black-friday/games-banner-mobile.png": 2344,
	"./black-friday/games-banner-mobile@2x.png": 2345,
	"./black-friday/games-banner.jpg": 2346,
	"./black-friday/games-banner@2x.jpg": 2347,
	"./black-friday/notebook.jpg": 2348,
	"./black-friday/phone.jpg": 2349,
	"./black-friday/portative-banner-mobile.png": 2350,
	"./black-friday/portative-banner-mobile@2x.png": 2351,
	"./black-friday/portative-banner.jpg": 2352,
	"./black-friday/portative-banner@2x.jpg": 2353,
	"./black-friday/salamet-mobile.png": 2354,
	"./black-friday/smartwatch-banner-mobile.jpg": 2355,
	"./black-friday/smartwatch-banner-mobile@2x.jpg": 2356,
	"./black-friday/smartwatch-banner.jpg": 2357,
	"./black-friday/smartwatch-banner@2x.jpg": 2358,
	"./black-friday/tv.jpg": 2359,
	"./black-friday/watch-banner-mobile.png": 2360,
	"./black-friday/watch-banner-mobile@2x.png": 2361,
	"./black-friday/watch-banner.jpg": 2362,
	"./black-friday/watch-banner@2x.jpg": 2363,
	"./black-friday/week-mobile.jpg": 2364,
	"./black-friday/weeks.jpg": 2365,
	"./cashback-day/appliance-2x.jpg": 2366,
	"./cashback-day/appliance.jpg": 2367,
	"./cashback-day/bonuscard-2x.jpg": 2368,
	"./cashback-day/bonuscard.jpg": 2369,
	"./cashback-day/coins-2x.jpg": 2370,
	"./cashback-day/coins.jpg": 2371,
	"./cashback-day/computer-2x.jpg": 2372,
	"./cashback-day/computer.jpg": 2373,
	"./cashback-day/date-2x.png": 2374,
	"./cashback-day/date.png": 2375,
	"./cashback-day/phone-2x.jpg": 2376,
	"./cashback-day/phone-2x.png": 2377,
	"./cashback-day/phone-mini-2x.png": 2378,
	"./cashback-day/phone-mini.png": 2379,
	"./cashback-day/phone.jpg": 2380,
	"./cashback-day/phone.png": 2381,
	"./cashback-day/powerbank-2x.png": 2382,
	"./cashback-day/powerbank.png": 2383,
	"./cashback-day/richman-2x.jpg": 2384,
	"./cashback-day/richman.jpg": 2385,
	"./cashback-day/shopping-2x.jpg": 2386,
	"./cashback-day/shopping.jpg": 2387,
	"./cashback-day/tv-2x.jpg": 2388,
	"./cashback-day/tv.jpg": 2389,
	"./cashback-day/vacuum-2x.png": 2390,
	"./cashback-day/vacuum.png": 2391,
	"./crazy-friday/123.jpg": 2392,
	"./crazy-friday/321.jpg": 2393,
	"./crazy-friday/bonus-card-banner.jpg": 2394,
	"./crazy-friday/chelik.png": 2395,
	"./crazy-friday/coffee-mobile.png": 2396,
	"./crazy-friday/coffee.png": 2397,
	"./crazy-friday/countdown-bg.png": 2398,
	"./crazy-friday/discount-mobile-m.png": 2399,
	"./crazy-friday/discount-mobile.png": 2400,
	"./crazy-friday/discount.png": 2401,
	"./crazy-friday/iPhoone14.png": 2402,
	"./crazy-friday/installment-iphone.png": 2403,
	"./crazy-friday/main-baner-iphone-mobile.png": 2404,
	"./crazy-friday/main-baner-iphone.png": 2405,
	"./crazy-friday/main-banner-bg-mobile.png": 2406,
	"./crazy-friday/main-banner-bg.jpg": 2407,
	"./crazy-friday/promocode-banner.jpg": 2408,
	"./crazy-friday/promocode-bg-mobile.png": 2409,
	"./crazy-friday/rassrochka-bg-mobile.png": 2410,
	"./crazy-friday/rassrochka-bg.png": 2411,
	"./crazy-friday/rub.png": 2412,
	"./cyber-monday-banner/main-banner-m.jpg": 2413,
	"./cyber-monday-banner/main-banner-m@2x.jpg": 2414,
	"./cyber-monday-banner/main-banner-m@3x.jpg": 2415,
	"./cyber-monday-banner/main-banner-mobile.jpg": 2416,
	"./cyber-monday-banner/main-banner-mobile@2x.jpg": 2417,
	"./cyber-monday-banner/main-banner-mobile@3x.jpg": 2418,
	"./cyber-monday-banner/main-banner.jpg": 2419,
	"./cyber-monday-banner/main-banner@2x.jpg": 2420,
	"./cyber-monday-banner/main-banner@3x.jpg": 2421,
	"./cyber-monday-banner/time-icon.svg": 2422,
	"./cyber-monday-banner/time.svg": 2423,
	"./cyber-monday/90.png": 2424,
	"./cyber-monday/90@2x.png": 2425,
	"./cyber-monday/appstore.png": 2426,
	"./cyber-monday/appstore@2x.png": 2427,
	"./cyber-monday/armchairs.jpg": 2428,
	"./cyber-monday/armchairs@2x.jpg": 2429,
	"./cyber-monday/armchairs_mobile.jpg": 2430,
	"./cyber-monday/bonus-mobile.png": 2431,
	"./cyber-monday/bonus-mobile@2x.png": 2432,
	"./cyber-monday/bonus.png": 2433,
	"./cyber-monday/bonus@2x.png": 2434,
	"./cyber-monday/cashback-mobile.png": 2435,
	"./cyber-monday/cashback-mobile@2x.png": 2436,
	"./cyber-monday/cashback.png": 2437,
	"./cyber-monday/cashback@2x.png": 2438,
	"./cyber-monday/copy-fon.png": 2439,
	"./cyber-monday/copy-fon@2x.png": 2440,
	"./cyber-monday/copy-mobile.png": 2441,
	"./cyber-monday/copy-mobile@2x.png": 2442,
	"./cyber-monday/copy.svg": 2443,
	"./cyber-monday/gadget-mobile.png": 2444,
	"./cyber-monday/gadget-mobile@2x.png": 2445,
	"./cyber-monday/gadget.png": 2446,
	"./cyber-monday/gadget@2x.png": 2447,
	"./cyber-monday/google.png": 2448,
	"./cyber-monday/google@2x.png": 2449,
	"./cyber-monday/headphones.jpg": 2450,
	"./cyber-monday/headphones@2x.jpg": 2451,
	"./cyber-monday/headphones_mobile.jpg": 2452,
	"./cyber-monday/joystick.png": 2453,
	"./cyber-monday/joystick@2x.png": 2454,
	"./cyber-monday/keyboard.jpg": 2455,
	"./cyber-monday/keyboard@2x.jpg": 2456,
	"./cyber-monday/laptop.jpg": 2457,
	"./cyber-monday/laptop@2x.jpg": 2458,
	"./cyber-monday/line.svg": 2459,
	"./cyber-monday/monitor.jpg": 2460,
	"./cyber-monday/monitor@2x.jpg": 2461,
	"./cyber-monday/monitor_mobile.jpg": 2462,
	"./cyber-monday/mouse.jpg": 2463,
	"./cyber-monday/mouse@2x.jpg": 2464,
	"./cyber-monday/mouse_mobile.jpg": 2465,
	"./cyber-monday/nav-fon.jpg": 2466,
	"./cyber-monday/nav-fon_mobile.jpg": 2467,
	"./cyber-monday/sale-mobile.png": 2468,
	"./cyber-monday/sale-mobile@2x.png": 2469,
	"./cyber-monday/sale.png": 2470,
	"./cyber-monday/sale@2x.png": 2471,
	"./cyber-monday/time-icon.svg": 2472,
	"./cyber-monday/time.png": 2473,
	"./cyber-monday/time@2x.png": 2474,
	"./cyber-monday/top-mobile.png": 2475,
	"./cyber-monday/top-mobile@2x.png": 2476,
	"./cyber-monday/top.jpg": 2477,
	"./cyber-monday/top@2x.jpg": 2478,
	"./cyber-monday/top@3x.jpg": 2479,
	"./cyber-monday/tv-mobile.png": 2480,
	"./cyber-monday/tv-mobile@2x.png": 2481,
	"./cyber-monday/tv.png": 2482,
	"./cyber-monday/tv@2x.png": 2483,
	"./cyber-monday/washing-mobile.png": 2484,
	"./cyber-monday/washing-mobile@2x.png": 2485,
	"./cyber-monday/washing.png": 2486,
	"./cyber-monday/washing@2x.png": 2487,
	"./cyberdays/armchair.jpg": 2488,
	"./cyberdays/armchair@2x.jpg": 2489,
	"./cyberdays/attention.jpg": 2490,
	"./cyberdays/background-header-bottom-mobile.jpg": 2491,
	"./cyberdays/background-header-bottom-mobile@2x.jpg": 2492,
	"./cyberdays/background-header-bottom.png": 2493,
	"./cyberdays/background-header-bottom@2x.png": 2494,
	"./cyberdays/background-header-left.jpg": 2495,
	"./cyberdays/background-header-left@2x.jpg": 2496,
	"./cyberdays/background-header-mobile.jpg": 2497,
	"./cyberdays/background-header-mobile@2x.jpg": 2498,
	"./cyberdays/background-header-right.jpg": 2499,
	"./cyberdays/background-header-right@2x.jpg": 2500,
	"./cyberdays/background-nav.jpg": 2501,
	"./cyberdays/background-nav@2x.jpg": 2502,
	"./cyberdays/banner-discount-appliance-mobile.jpg": 2503,
	"./cyberdays/banner-discount-appliance-mobile@2x.jpg": 2504,
	"./cyberdays/banner-discount-appliance.jpg": 2505,
	"./cyberdays/banner-discount-appliance@2x.jpg": 2506,
	"./cyberdays/banner-discount-chemicals.jpg": 2507,
	"./cyberdays/banner-discount-chemicals@2x.jpg": 2508,
	"./cyberdays/banner-discount-kitchen-mobile.jpg": 2509,
	"./cyberdays/banner-discount-kitchen-mobile@2x.jpg": 2510,
	"./cyberdays/banner-discount-kitchen.jpg": 2511,
	"./cyberdays/banner-discount-kitchen@2x.jpg": 2512,
	"./cyberdays/banner-first-order.jpg": 2513,
	"./cyberdays/banner-first-order@2x.jpg": 2514,
	"./cyberdays/banner-free-delivery-mobile.jpg": 2515,
	"./cyberdays/banner-free-delivery-mobile@2x.jpg": 2516,
	"./cyberdays/banner-free-delivery.jpg": 2517,
	"./cyberdays/banner-free-delivery@2x.jpg": 2518,
	"./cyberdays/banner-main.jpg": 2519,
	"./cyberdays/banner-top-center-mobile.jpg": 2520,
	"./cyberdays/banner-top-center-mobile@2x.jpg": 2521,
	"./cyberdays/banner-top-center.jpg": 2522,
	"./cyberdays/banner-top-center@2x.jpg": 2523,
	"./cyberdays/computer.jpg": 2524,
	"./cyberdays/cyberdays.svg": 2525,
	"./cyberdays/divider-nav-mobile.jpg": 2526,
	"./cyberdays/divider-nav-mobile@2x.jpg": 2527,
	"./cyberdays/drone.jpg": 2528,
	"./cyberdays/drone@2x.jpg": 2529,
	"./cyberdays/earbuds.jpg": 2530,
	"./cyberdays/fridge.jpg": 2531,
	"./cyberdays/headphone.jpg": 2532,
	"./cyberdays/headphone@2x.jpg": 2533,
	"./cyberdays/keyboard.jpg": 2534,
	"./cyberdays/keyboard@2x.jpg": 2535,
	"./cyberdays/line.jpg": 2536,
	"./cyberdays/line@2x.jpg": 2537,
	"./cyberdays/monitor.jpg": 2538,
	"./cyberdays/monitor@2x.jpg": 2539,
	"./cyberdays/mouse.jpg": 2540,
	"./cyberdays/mouse@2x.jpg": 2541,
	"./cyberdays/notebook.jpg": 2542,
	"./cyberdays/notebook@2x.jpg": 2543,
	"./cyberdays/phone.jpg": 2544,
	"./cyberdays/product-fridge.jpg": 2545,
	"./cyberdays/product-monitor.jpg": 2546,
	"./cyberdays/product-phone.jpg": 2547,
	"./cyberdays/product-tablet.jpg": 2548,
	"./cyberdays/smartphone.jpg": 2549,
	"./cyberdays/smartwatch.jpg": 2550,
	"./cyberdays/tablet.jpg": 2551,
	"./cyberdays/tv.jpg": 2552,
	"./i-love-you/bag.png": 2553,
	"./i-love-you/bag@2x.png": 2554,
	"./i-love-you/box.png": 2555,
	"./i-love-you/box@2x.png": 2556,
	"./i-love-you/bulb-smiley.svg": 2557,
	"./i-love-you/card.png": 2558,
	"./i-love-you/card@2x.png": 2559,
	"./i-love-you/delivery-icons.svg": 2560,
	"./i-love-you/eyes-smiley.svg": 2561,
	"./i-love-you/fridge-1.png": 2562,
	"./i-love-you/fridge-1@2x.png": 2563,
	"./i-love-you/fridge-2.png": 2564,
	"./i-love-you/fridge-2@2x.png": 2565,
	"./i-love-you/fridge-mobile.png": 2566,
	"./i-love-you/fridge-mobile@2x.png": 2567,
	"./i-love-you/fridge.jpg": 2568,
	"./i-love-you/fridge@2x.jpg": 2569,
	"./i-love-you/header-background-mobile.svg": 2570,
	"./i-love-you/header-background.svg": 2571,
	"./i-love-you/header-bonuses.svg": 2572,
	"./i-love-you/header-phone-mobile.png": 2573,
	"./i-love-you/header-phone-mobile@2x.png": 2574,
	"./i-love-you/header-phone.png": 2575,
	"./i-love-you/header-phone@2x.png": 2576,
	"./i-love-you/letter-smiley.svg": 2577,
	"./i-love-you/magic-1.png": 2578,
	"./i-love-you/magic-1@2x.png": 2579,
	"./i-love-you/magic-2.png": 2580,
	"./i-love-you/magic-2@2x.png": 2581,
	"./i-love-you/magic-mobile.png": 2582,
	"./i-love-you/magic-mobile@2x.png": 2583,
	"./i-love-you/magic.jpg": 2584,
	"./i-love-you/magic@2x.jpg": 2585,
	"./i-love-you/man-smiley.svg": 2586,
	"./i-love-you/roborock.png": 2587,
	"./i-love-you/roborock@2x.png": 2588,
	"./i-love-you/sharp.svg": 2589,
	"./i-love-you/wallet-smiley.svg": 2590,
	"./i-love-you/woman-smiley.svg": 2591,
	"./installment/installment.svg": 2592,
	"./love-promo/banner-img.png": 2593,
	"./love-promo/banner-img@2x.png": 2594,
	"./love-promo/banner-img@3x.png": 2595,
	"./love-promo/banner/banner-1.png": 2596,
	"./love-promo/banner/banner-1@2x.png": 2597,
	"./love-promo/banner/banner-2.png": 2598,
	"./love-promo/banner/banner-2@2x.png": 2599,
	"./love-promo/banner/banner-3.png": 2600,
	"./love-promo/banner/banner-3@2x.png": 2601,
	"./love-promo/banner/banner-3_mobile.jpg": 2602,
	"./love-promo/banner/banner-3_mobile@2x.jpg": 2603,
	"./love-promo/banner/banner-4.png": 2604,
	"./love-promo/banner/banner-4@2x.png": 2605,
	"./love-promo/bonus-bg.jpg": 2606,
	"./love-promo/bonus-bg@2x.jpg": 2607,
	"./love-promo/bonus-bg@3x.jpg": 2608,
	"./love-promo/btn-bg.jpg": 2609,
	"./love-promo/category/Tv.jpg": 2610,
	"./love-promo/category/Tv@2x.jpg": 2611,
	"./love-promo/category/Tv@3x.jpg": 2612,
	"./love-promo/category/blender.jpg": 2613,
	"./love-promo/category/blender@2x.jpg": 2614,
	"./love-promo/category/blender@3x.jpg": 2615,
	"./love-promo/category/chemicals.jpg": 2616,
	"./love-promo/category/chemicals@2x.jpg": 2617,
	"./love-promo/category/chemicals@3x.jpg": 2618,
	"./love-promo/category/iphone.jpg": 2619,
	"./love-promo/category/iphone@2x.jpg": 2620,
	"./love-promo/category/iphone@3x.jpg": 2621,
	"./love-promo/category/notebook.jpg": 2622,
	"./love-promo/category/notebook@2x.jpg": 2623,
	"./love-promo/category/notebook@3x.jpg": 2624,
	"./love-promo/complitation/airpods.jpg": 2625,
	"./love-promo/complitation/airpods@2x.jpg": 2626,
	"./love-promo/complitation/airpods@3x.jpg": 2627,
	"./love-promo/complitation/heat.jpg": 2628,
	"./love-promo/complitation/heat@2x.jpg": 2629,
	"./love-promo/complitation/heat@3x.jpg": 2630,
	"./love-promo/complitation/iphone.jpg": 2631,
	"./love-promo/complitation/iphone@2x.jpg": 2632,
	"./love-promo/complitation/iphone@3x.jpg": 2633,
	"./love-promo/copy-svg-mobile.svg": 2634,
	"./love-promo/copy-svg.svg": 2635,
	"./love-promo/promocode-bg.jpg": 2636,
	"./love-promo/promocode-bg@2x.jpg": 2637,
	"./love-promo/promocode-bg@3x.jpg": 2638,
	"./main-banner-mobile.mp4": 2639,
	"./main-banner.mp4": 2640,
	"./merch/merch-icon-2.svg": 1718,
	"./merch/merch-icon.svg": 1717,
	"./merch/merch-icon_mobile.svg": 1719,
	"./merch/merch.jpg": 2641,
	"./merch/merch__about.jpg": 1675,
	"./merch/merch__info.png": 1501,
	"./merch/merch__info@2x.png": 2642,
	"./merch/merch__info_mobile.png": 1674,
	"./merch/merch__postcard2.png": 2643,
	"./merch/merch__video.mp4": 1667,
	"./merch/merch__video_mobile.mp4": 1668,
	"./merch/merch_menu-bookmarks.jpg": 1669,
	"./merch/merch_menu-bracelet.jpg": 1670,
	"./merch/merch_menu-postcards.jpg": 1671,
	"./merch/merch_menu-shirts.jpg": 1672,
	"./merch/merch_menu-shopper.jpg": 1673,
	"./merch/slide1-2.png": 1683,
	"./merch/slide1-2@2x.png": 1684,
	"./merch/slide1-3.png": 1685,
	"./merch/slide1-3@2x.png": 1686,
	"./merch/slide1-@2x.png": 1682,
	"./merch/slide1.png": 1681,
	"./merch/slide2-1.png": 1687,
	"./merch/slide2-1@2x.png": 1688,
	"./merch/slide2-2.png": 1689,
	"./merch/slide2-2@2x.png": 1690,
	"./merch/slide2-3.png": 1691,
	"./merch/slide2-3@2x.png": 1692,
	"./merch/slide3-1.png": 1693,
	"./merch/slide3-1@2x.png": 1694,
	"./merch/slide3-2.png": 1695,
	"./merch/slide3-2@2x.png": 1696,
	"./merch/slide3-3.png": 1697,
	"./merch/slide3-3@2x.png": 1698,
	"./merch/slide4-1.png": 1699,
	"./merch/slide4-1@2x.png": 1700,
	"./merch/slide4-2.png": 1701,
	"./merch/slide4-2@2x.png": 1702,
	"./merch/slide4-3.png": 1703,
	"./merch/slide4-3@2x.png": 1704,
	"./merch/slide5-1.png": 1705,
	"./merch/slide5-1@2x.png": 1706,
	"./merch/slide5-2.png": 1707,
	"./merch/slide5-2@2x.png": 1708,
	"./merch/slide5-3.png": 1709,
	"./merch/slide5-3@2x.png": 1710,
	"./merch/slide6-1.png": 1711,
	"./merch/slide6-1@2x.png": 1712,
	"./merch/slide6-2.png": 1713,
	"./merch/slide6-2@2x.png": 1714,
	"./merch/slide6-3.png": 1715,
	"./merch/slide6-3@2x.png": 1716,
	"./merch/video-footer.mp4": 1676,
	"./new-year/2023.svg": 2644,
	"./new-year/banner-1.png": 2645,
	"./new-year/banner-1@2x.png": 2646,
	"./new-year/banner-1_mobile.jpg": 2647,
	"./new-year/banner-1_mobile@2x.jpg": 2648,
	"./new-year/banner-2.png": 2649,
	"./new-year/banner-2@2x.png": 2650,
	"./new-year/banner-2_mobile.jpg": 2651,
	"./new-year/banner-2_mobile@2x.jpg": 2652,
	"./new-year/banner-3.png": 2653,
	"./new-year/banner-3@2x.png": 2654,
	"./new-year/banner-3_mobile.jpg": 2655,
	"./new-year/banner-3_mobile@2x.jpg": 2656,
	"./new-year/banner-4.png": 2657,
	"./new-year/banner-4@2x.png": 2658,
	"./new-year/banner-fon.jpg": 2659,
	"./new-year/banner-title-mobile.svg": 1846,
	"./new-year/banner-title.svg": 1847,
	"./new-year/banner-top-1.png": 2660,
	"./new-year/banner-top-1@2x.png": 2661,
	"./new-year/banner-top-2.png": 2662,
	"./new-year/banner-top-2@2x.png": 2663,
	"./new-year/banner-top-2_mobile.png": 2664,
	"./new-year/banner-top-2_mobile@2x.png": 2665,
	"./new-year/banner-top-3.png": 2666,
	"./new-year/banner-top-3@2x.png": 2667,
	"./new-year/banner-top-3_mobile.png": 2668,
	"./new-year/banner-top-3_mobile@2x.png": 2669,
	"./new-year/bonus-fon.png": 2670,
	"./new-year/bonus-value.png": 2671,
	"./new-year/bonus-value@2x.png": 2672,
	"./new-year/bonus.png": 2673,
	"./new-year/copy.svg": 2674,
	"./new-year/fir-center.jpg": 2675,
	"./new-year/fir-center@2x.jpg": 2676,
	"./new-year/fir-tree.png": 1516,
	"./new-year/fir-tree@2x.png": 1848,
	"./new-year/fir.svg": 2677,
	"./new-year/fir_mobile.svg": 2678,
	"./new-year/gift-2.png": 2679,
	"./new-year/gift-2@2x.png": 2680,
	"./new-year/gift.png": 1404,
	"./new-year/gift@2x.png": 1517,
	"./new-year/main-banner-mobile.jpg": 2681,
	"./new-year/main-banner-mobile@2x.jpg": 2682,
	"./new-year/main-banner-mobile@3x.jpg": 2683,
	"./new-year/mixer.jpg": 2684,
	"./new-year/mixer@2x.jpg": 2685,
	"./new-year/notebook.jpg": 2686,
	"./new-year/notebook@2x.jpg": 2687,
	"./new-year/phone.jpg": 2688,
	"./new-year/phone@2x.jpg": 2689,
	"./new-year/playstation.png": 2690,
	"./new-year/playstation@2x.png": 2691,
	"./new-year/promocode-copy.png": 2692,
	"./new-year/promocode-copy@2x.png": 2693,
	"./new-year/promocode_mobile-copy.png": 2694,
	"./new-year/promocode_mobile-copy@2x.png": 2695,
	"./new-year/promocode_mobile.png": 2696,
	"./new-year/promocode_mobile@2x.png": 2697,
	"./new-year/ps5.png": 2698,
	"./new-year/ps5@2x.png": 2699,
	"./new-year/purchases.jpg": 2700,
	"./new-year/purchases@2x.jpg": 2701,
	"./new-year/red.png": 2702,
	"./new-year/sale.png": 2703,
	"./new-year/sale@2x.png": 2704,
	"./new-year/shampoo.jpg": 2705,
	"./new-year/shampoo@2x.jpg": 2706,
	"./new-year/tv.jpg": 2707,
	"./new-year/tv@2x.jpg": 2708,
	"./new-year/yellow.jpg": 2709,
	"./new-year/yellow.png": 2710,
	"./quiz2025/bonus.svg": 2711,
	"./quiz2025/dossier1.png": 2712,
	"./quiz2025/dossier2.png": 2713,
	"./quiz2025/dossier3.png": 2714,
	"./quiz2025/dossier4.png": 2715,
	"./quiz2025/gradient.png": 2716,
	"./quiz2025/snowflake.png": 2717,
	"./quiz2025/start-bg.png": 2718,
	"./ramadan-banner-mobile.mp4": 2719,
	"./ramadan-banner.mp4": 2720,
	"./ramadan/bonus-gradient.svg": 2721,
	"./ramadan/bonus.svg": 1458,
	"./ramadan/bonus2.png": 2722,
	"./ramadan/check.svg": 1731,
	"./ramadan/close.svg": 1736,
	"./ramadan/error.svg": 1730,
	"./ramadan/profile.svg": 1732,
	"./ramadan/rules.svg": 1733,
	"./ramadan/sale-gradient.svg": 2723,
	"./ramadan/sale.jpg": 2724,
	"./ramadan/sale.svg": 2725,
	"./ramadan/start-mobile.jpg": 1737,
	"./ramadan/start.jpg": 1734,
	"./ramadan/wrap-mobile-375.jpg": 1739,
	"./ramadan/wrap-mobile.jpg": 1738,
	"./ramadan/wrap.jpg": 1735,
	"./shopping/banner-1.png": 2726,
	"./shopping/banner-1@2x.png": 2727,
	"./shopping/banner-2.png": 2728,
	"./shopping/banner-2@2x.png": 2729,
	"./shopping/banner-2_mobile.jpg": 2730,
	"./shopping/banner-2_mobile@2x.jpg": 2731,
	"./shopping/banner-3.png": 2732,
	"./shopping/banner-3@2x.png": 2733,
	"./shopping/banner-3_mobile.jpg": 2734,
	"./shopping/banner-3_mobile@2x.jpg": 2735,
	"./shopping/banner-4.png": 2736,
	"./shopping/banner-4@2x.png": 2737,
	"./shopping/banner-5.png": 2738,
	"./shopping/banner-5@2x.png": 2739,
	"./shopping/banner-6.png": 2740,
	"./shopping/banner-6@2x.png": 2741,
	"./shopping/banner-7.png": 2742,
	"./shopping/banner-7@2x.png": 2743,
	"./shopping/banner-fon.jpg": 2744,
	"./shopping/bonus-3.png": 2745,
	"./shopping/bonus-3@2x.png": 2746,
	"./shopping/bonus1-@2x.png": 2747,
	"./shopping/bonus1.png": 2748,
	"./shopping/bonus2-@2x.png": 2749,
	"./shopping/bonus2.png": 2750,
	"./shopping/message-white.png": 2751,
	"./shopping/messages-fon.png": 2752,
	"./shopping/promocode.png": 2753,
	"./shopping/promocode@2x.png": 2754,
	"./shopping/shopping-top.png": 2755,
	"./shopping/shopping-top@2x.png": 2756,
	"./shopping/shopping-top_mobile.png": 2757,
	"./shopping/shopping-top_mobile@2x.png": 2758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1845;